import { handleActions } from "redux-actions";
import * as fieldsConfigActions from "../actions/fieldsActions";

let filtersState = {
  requestTypes: null,
  requestViews: null,
  requestStatuses: null,
  orderStatuses: null,
  maintenanceLevels: null,
  paymentMethods: null,
  serviceTypes: null,
  weekDays: null,
  regions: null,
  subjects: null,
  roles: null,
  vehicleCategories: null,
  citizenships: null,
  identityDocuments: null,
  foreignLanguages: null,
  profileStatus: null,
  documentsFillTypes: null,
  documentsStatuses: null,
  documentsTypes: null,
  serviceAdditionals: null,
  performers: null,
  monetizationTemplates: null
};

export const Filters = handleActions(
  {
    [fieldsConfigActions.getDocumentsFillTypes]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getDocumentsFillTypesSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        documentsFillTypes: payload.data
      };
    },
    [fieldsConfigActions.getDocumentsFillTypesFailure]: (state, action) => {
      let { payload } = action;
      console.log("Request Statuses Error", payload.data.message);
      return {
        ...state,
        documentsFillTypes: payload.data.message
      };
    },

    [fieldsConfigActions.getDocumentsStatuses]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getDocumentsStatusesSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        documentsStatuses: payload.data
      };
    },
    [fieldsConfigActions.getDocumentsStatusesFailure]: (state, action) => {
      let { payload } = action;
      console.log("Request Statuses Error", payload.data.message);
      return {
        ...state,
        documentsStatuses: payload.data.message
      };
    },

    [fieldsConfigActions.getDocumentsTypes]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getDocumentsTypesSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        documentsTypes: payload.data
      };
    },
    [fieldsConfigActions.getDocumentsTypesFailure]: (state, action) => {
      let { payload } = action;
      console.log("Request Statuses Error", payload.data.message);
      return {
        ...state,
        documentsTypes: payload.data.message
      };
    },

    [fieldsConfigActions.getRequestStatuses]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getRequestStatusesSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        requestStatuses: payload.data
      };
    },
    [fieldsConfigActions.getRequestStatusesError]: (state, action) => {
      let { payload } = action;
      console.log("Request Statuses Error", payload.data.message);
      return {
        ...state,
        requestStatuses: payload.data.message
      };
    },

    [fieldsConfigActions.getOrderStatuses]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getOrderStatusesSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        orderStatuses: payload.data
      };
    },
    [fieldsConfigActions.getOrderStatusesError]: (state, action) => {
      let { payload } = action;
      console.log("Order Statuses Error", payload.data.message);
      return {
        ...state,
        orderStatuses: payload.data.message
      };
    },

    [fieldsConfigActions.getRequestTypes]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getRequestTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        requestTypes: payload.data
      });
    },
    [fieldsConfigActions.getRequestTypesError]: (state, action) => {
      let { payload } = action;
      console.log("Request Types Error", payload.data.message);
      return (state = {
        ...state,
        requestTypes: payload.data.message
      });
    },

    [fieldsConfigActions.getRequestViews]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getRequestViewsSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        requestViews: payload.data
      });
    },
    [fieldsConfigActions.getRequestViewsError]: (state, action) => {
      let { payload } = action;
      console.log("Request Types Error", payload.data.message);
      return (state = {
        ...state,
        requestViews: payload.data.message
      });
    },

    [fieldsConfigActions.getMaintenanceLevels]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getMaintenanceLevelsSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        maintenanceLevels: payload.data
      });
    },
    [fieldsConfigActions.getMaintenanceLevelsError]: (state, action) => {
      let { payload } = action;
      console.log("Maintenance Levels Error", payload.data.message);
      return (state = {
        ...state,
        maintenanceLevels: payload.data.message
      });
    },

    [fieldsConfigActions.getPaymentMethods]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getPaymentMethodsSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        paymentMethods: payload.data
      });
    },
    [fieldsConfigActions.getPaymentMethodsError]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        paymentMethods: payload.data.message
      });
    },

    [fieldsConfigActions.getServiceTypes]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getServiceTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        serviceTypes: payload.data
      });
    },
    [fieldsConfigActions.getServiceTypesError]: (state, action) => {
      let { payload } = action;
      console.log("Service Types Error", payload.data.message);
      return (state = {
        ...state,
        serviceTypes: payload.data.message
      });
    },

    [fieldsConfigActions.getRegions]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getRegionsSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        regions: payload.data
      });
    },
    [fieldsConfigActions.getRegionsError]: (state, action) => {
      let { payload } = action;
      console.log("Regions Error", payload.data.message);
      return (state = {
        ...state,
        regions: payload.data.message
      });
    },

    [fieldsConfigActions.getSubjects]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getSubjectsSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        subjects: payload.data
      });
    },
    [fieldsConfigActions.getSubjectsError]: (state, action) => {
      let { payload } = action;
      console.log("Subjects Error", payload.data.message);
      return (state = {
        ...state,
        subjects: payload.data.message
      });
    },

    [fieldsConfigActions.getWeekDays]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getWeekDaysSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        weekDays: payload.data
      });
    },
    [fieldsConfigActions.getWeekDaysError]: (state, action) => {
      let { payload } = action;
      console.log("Week Days Error", payload.data.message);
      return (state = {
        ...state,
        weekDays: payload.data.message
      });
    },

    [fieldsConfigActions.getRoles]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getRolesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        roles: payload.data
      });
    },
    [fieldsConfigActions.getRolesError]: (state, action) => {
      let { payload } = action;
      console.log("Roles Error", payload.data.message);
      return (state = {
        ...state,
        roles: payload.data.message
      });
    },

    [fieldsConfigActions.getVehicleCategories]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getVehicleCategoriesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        vehicleCategories: payload.data
      });
    },
    [fieldsConfigActions.getVehicleCategoriesError]: (state, action) => {
      let { payload } = action;
      console.log("Vehicle Categories Error", payload.data.message);
      return (state = {
        ...state,
        vehicleCategories: payload.data.message
      });
    },

    [fieldsConfigActions.getCitizenships]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getCitizenshipsSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        citizenships: payload.data
      });
    },
    [fieldsConfigActions.getCitizenshipsError]: (state, action) => {
      let { payload } = action;
      console.log("Citizenships Error", payload.data.message);
      return (state = {
        ...state,
        citizenships: payload.data.message
      });
    },

    [fieldsConfigActions.getIdentityDocuments]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getIdentityDocumentsSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        identityDocuments: payload.data
      });
    },
    [fieldsConfigActions.getIdentityDocumentsError]: (state, action) => {
      let { payload } = action;
      console.log("Identity Documents Error", payload.data.message);
      return (state = {
        ...state,
        identityDocuments: payload.data.message
      });
    },

    [fieldsConfigActions.getForeignLanguages]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getForeignLanguagesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        foreignLanguages: payload.data
      });
    },
    [fieldsConfigActions.getForeignLanguagesError]: (state, action) => {
      let { payload } = action;
      console.log("Foreign Languages Error", payload.data.message);
      return (state = {
        ...state,
        foreignLanguages: payload.data.message
      });
    },

    [fieldsConfigActions.getProfileStatus]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getProfileStatusSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        profileStatus: payload.data
      });
    },
    [fieldsConfigActions.getProfileStatusError]: (state, action) => {
      let { payload } = action;
      console.log("Profile Status Error", payload.data.message);
      return (state = {
        ...state,
        profileStatus: payload.data.message
      });
    },

    [fieldsConfigActions.getServiceAdditionals]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getServiceAdditionalsSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        serviceAdditionals: payload.data
      });
    },
    [fieldsConfigActions.getServiceAdditionalsError]: (state, action) => {
      let { payload } = action;
      console.log("Service Additionals Error", payload.data.message);
      return (state = {
        ...state,
        serviceAdditionals: payload.data.message
      });
    },

    [fieldsConfigActions.getPerformers]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getPerformersSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        performers: payload.data
      });
    },
    [fieldsConfigActions.getPerformersFailure]: (state, action) => {
      let { payload } = action;
      console.log("Profile Status Error", payload.data.message);
      return (state = {
        ...state,
        performers: payload.data.message
      });
    },

    [fieldsConfigActions.getMonetizationTemplates]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getMonetizationTemplatesSuccess]: (state, action) => {
      return {
        ...state,
        monetizationTemplates: action.payload
      };
    },
    [fieldsConfigActions.getMonetizationTemplatesError]: (state, action) => {
      let { payload } = action;
      console.log(action);
      console.log("Monetization templates Error", payload.message);
      return (state = {
        ...state,
        monetizationTemplates: payload.data.message
      });
    },
    [fieldsConfigActions.clearFilters]: () => filtersState
  },
  filtersState
);
